<template>
  <div class="imprint-view-container">
    <h2 class="header">Impressum</h2>
    <p>
      Informationspflicht laut §5 E-Commerce Gesetz, §14 Unternehmensgesetzbuch,
      §63 Gewerbeordnung und Offenlegungspflicht laut §25 Mediengesetz.
    </p>
    <p>
      dafür gem. GmbH<br />J.-G.-Ulmer-Straße 2, <br />6850 Dornbirn,
      <br />Österreich
    </p>
    <p>
      <strong>Firmenbuchgericht:</strong> Feldkirch<br />
      <strong>Firmensitz:</strong> 6850 Dornbirn
    </p>
    <p><strong>Tel.:</strong> +43 5576 20 770<br /></p>
    <p style="margin-top: 15px">
      Quelle: Erstellt mit dem Impressum Generator von
      <a
        title="Impressum Generator von Content Marketing AdSimple"
        href="https://www.adsimple.at"
        target="_blank"
        rel="follow"
        >adsimple.at</a
      > in Kooperation mit
      <a
        href="https://www.wallentin.cc"
        target="_blank"
        rel="follow"
        title="Schönheitsbehandlungen in Wien - mit und ohne Operation bei Dr. Valentin"
        >wallentin.cc</a
      >
    </p>
    <h2>EU-Streitschlichtung</h2>
    <p>
      Gemäß Verordnung über Online-Streitbeilegung in Verbraucherangelegenheiten
      (ODR-Verordnung) möchten wir Sie über die Online-Streitbeilegungsplattform
      (OS-Plattform) informieren.<br />
      Verbraucher haben die Möglichkeit, Beschwerden an die Online
      Streitbeilegungsplattform der Europäischen Kommission unter
      <a
        href="https://ec.europa.eu/consumers/odr/main/index.cfm?event=main.home2.show&lng=DE"
        target="_blank"
        >http://ec.europa.eu/odr?tid=121204212</a
      >
      zu richten. Die dafür notwendigen Kontaktdaten finden Sie oberhalb in
      unserem Impressum.
    </p>
    <p>
      Wir möchten Sie jedoch darauf hinweisen, dass wir nicht bereit oder
      verpflichtet sind, an Streitbeilegungsverfahren vor einer
      Verbraucherschlichtungsstelle teilzunehmen.
    </p>
    <h2>Haftung für Inhalte dieser Webseite</h2>
    <p>
      Wir entwickeln die Inhalte dieser Webseite ständig weiter und bemühen uns
      korrekte und aktuelle Informationen bereitzustellen. Leider können wir
      keine Haftung für die Korrektheit aller Inhalte auf dieser Webseite
      übernehmen, speziell für jene die seitens Dritter bereitgestellt wurden.
    </p>
    <p>
      Sollten Ihnen problematische oder rechtswidrige Inhalte auffallen, bitten
      wir Sie uns umgehend zu kontaktieren, Sie finden die Kontaktdaten im
      Impressum.
    </p>
    <h2>Haftung für Links auf dieser Webseite</h2>
    <p>
      Unsere Webseite enthält Links zu anderen Webseiten für deren Inhalt wir
      nicht verantwortlich sind. Haftung für verlinkte Websites besteht laut
      <a
        href="https://www.ris.bka.gv.at/Dokument.wxe?Abfrage=Bundesnormen&Dokumentnummer=NOR40025813&tid=121204212"
        target="_blank"
        rel="noopener"
        >§ 17 ECG</a
      >
      für uns nicht, da wir keine Kenntnis rechtswidriger Tätigkeiten hatten und
      haben, uns solche Rechtswidrigkeiten auch bisher nicht aufgefallen sind
      und wir Links sofort entfernen würden, wenn uns Rechtswidrigkeiten bekannt
      werden.
    </p>
    <p>
      Wenn Ihnen rechtswidrige Links auf unserer Website auffallen, bitten wir
      Sie uns zu kontaktieren, Sie finden die Kontaktdaten im Impressum.
    </p>
    <h2>Urheberrechtshinweis</h2>
    <p>
      Alle Inhalte dieser Webseite (Bilder, Fotos, Texte, Videos) unterliegen
      dem Urheberrecht. Falls notwendig, werden wir die unerlaubte Nutzung von
      Teilen der Inhalte unserer Seite rechtlich verfolgen.
    </p>
    <p>
      Sollten Sie auf dieser Webseite Inhalte finden, die das Urheberrecht
      verletzen, bitten wir Sie uns zu kontaktieren.
    </p>
    <h2>Bildernachweis</h2>
    <p>
      Die Bilder, Fotos und Grafiken auf dieser Webseite sind urheberrechtlich
      geschützt.
    </p>
    <p>Die Bilderrechte liegen bei den folgenden Fotografen und Unternehmen:</p>
    <ul>
      <li>Fotograf Mustermann</li>
    </ul>
    <h1 class="dsgvo">Datenschutzerklärung</h1>
    <h2>Datenschutz</h2>
    <p>
      Wir haben diese Datenschutzerklärung (Fassung 21.11.2019-121204212)
      verfasst, um Ihnen gemäß der Vorgaben der Datenschutz-Grundverordnung (EU)
      2016/679 und dem
      <a
        href="https://www.ris.bka.gv.at/GeltendeFassung.wxe?Abfrage=Bundesnormen&Gesetzesnummer=10001597&tid=121204212"
        target="_blank"
        rel="noopener"
        >Datenschutzgesetz (DSG)</a
      >
      zu erklären, welche Informationen wir sammeln, wie wir Daten verwenden und
      welche Entscheidungsmöglichkeiten Sie als Besucher dieser Webseite haben.
    </p>
    <p>
      Leider liegt es in der Natur der Sache, dass diese Erklärungen sehr
      technisch klingen. Wir haben uns bei der Erstellung jedoch bemüht die
      wichtigsten Dinge so einfach und klar wie möglich zu beschreiben.
    </p>
    <h2>Automatische Datenspeicherung</h2>
    <p>
      Wenn Sie heutzutage Webseiten besuchen, werden gewisse Informationen
      automatisch erstellt und gespeichert, so auch auf dieser Webseite.
    </p>
    <p>
      Wenn Sie unsere Webseite so wie jetzt gerade besuchen, speichert unser
      Webserver (Computer auf dem diese Webseite gespeichert ist) automatisch
      Daten wie
    </p>
    <ul>
      <li>die Adresse (URL) der aufgerufenen Webseite</li>
      <li>Browser und Browserversion</li>
      <li>das verwendete Betriebssystem</li>
      <li>die Adresse (URL) der zuvor besuchten Seite (Referrer URL)</li>
      <li>
        den Hostname und die IP-Adresse des Geräts von welchem aus zugegriffen
        wird
      </li>
      <li>Datum und Uhrzeit</li>
    </ul>
    <p>in Dateien (Webserver-Logfiles).</p>
    <p>
      In der Regel werden Webserver-Logfiles zwei Wochen gespeichert und danach
      automatisch gelöscht. Wir geben diese Daten nicht weiter, können jedoch
      nicht ausschließen, dass diese Daten beim Vorliegen von rechtswidrigem
      Verhalten eingesehen werden.
    </p>
    <h2>Rechte laut Datenschutzgrundverordnung</h2>
    <p>
      Ihnen stehen laut den Bestimmungen der DSGVO und des österreichischen
      <a
        href="https://www.ris.bka.gv.at/GeltendeFassung.wxe?Abfrage=Bundesnormen&Gesetzesnummer=10001597&tid=121204212"
        target="_blank"
        rel="noopener"
        >Datenschutzgesetzes (DSG)</a
      >
      grundsätzlich die folgende Rechte zu:
    </p>
    <ul>
      <li>Recht auf Berichtigung (Artikel 16 DSGVO)</li>
      <li>
        Recht auf Löschung („Recht auf Vergessenwerden“) (Artikel 17 DSGVO)
      </li>
      <li>Recht auf Einschränkung der Verarbeitung (Artikel 18 DSGVO)</li>
      <li>
        Recht auf Benachrichtigung – Mitteilungspflicht im Zusammenhang mit der
        Berichtigung oder Löschung personenbezogener Daten oder der
        Einschränkung der Verarbeitung (Artikel 19 DSGVO)
      </li>
      <li>Recht auf Datenübertragbarkeit (Artikel 20 DSGVO)</li>
      <li>Widerspruchsrecht (Artikel 21 DSGVO)</li>
      <li>
        Recht, nicht einer ausschließlich auf einer automatisierten Verarbeitung
        — einschließlich Profiling — beruhenden Entscheidung unterworfen zu
        werden (Artikel 22 DSGVO)
      </li>
    </ul>
    <p>
      Wenn Sie glauben, dass die Verarbeitung Ihrer Daten gegen das
      Datenschutzrecht verstößt oder Ihre datenschutzrechtlichen Ansprüche sonst
      in einer Weise verletzt worden sind, können Sie sich bei der
      Aufsichtsbehörde beschweren, welche in Österreich die Datenschutzbehörde
      ist, deren Webseite Sie unter
      <a href="https://www.dsb.gv.at/?tid=121204212">https://www.dsb.gv.at/</a>
      finden.
    </p>
    <h2>Auswertung des Besucherverhaltens</h2>
    <p>
      In der folgenden Datenschutzerklärung informieren wir Sie darüber, ob und
      wie wir Daten Ihres Besuchs dieser Website auswerten. Die Auswertung der
      gesammelten Daten erfolgt in der Regel anonym und wir können von Ihrem
      Verhalten auf dieser Website nicht auf Ihre Person schließen.
    </p>
    <p>
      Mehr über Möglichkeiten dieser Auswertung der Besuchsdaten zu
      widersprechen erfahren Sie in der folgenden Datenschutzerklärung.
    </p>
    <h2>TLS-Verschlüsselung mit https</h2>
    <p>
      Wir verwenden https um Daten abhörsicher im Internet zu übertragen
      (Datenschutz durch Technikgestaltung
      <a
        href="https://eur-lex.europa.eu/legal-content/DE/TXT/HTML/?uri=CELEX:32016R0679&from=DE&tid=121204212"
        target="_blank"
        rel="noopener"
        >Artikel 25 Absatz 1 DSGVO</a
      >). Durch den Einsatz von TLS (Transport Layer Security), einem
      Verschlüsselungsprotokoll zur sicheren Datenübertragung im Internet können
      wir den Schutz vertraulicher Daten sicherstellen. Sie erkennen die
      Benutzung dieser Absicherung der Datenübertragung am kleinen Schlosssymbol
      links oben im Browser und der Verwendung des Schemas https (anstatt http)
      als Teil unserer Internetadresse.
    </p>
    <h2>Google Fonts Datenschutzerklärung</h2>
    <p>
      Auf unserer Webseite verwenden wir Google Fonts. Das sind die
      “Google-Schriften” der Firma Google Inc. (1600 Amphitheatre Parkway
      Mountain View, CA 94043, USA).
    </p>
    <p>
      Für die Verwendung von Google-Schriftarten müssen Sie sich nicht anmelden
      bzw. ein Passwort hinterlegen. Weiters werden auch keine Cookies in Ihrem
      Browser gespeichert. Die Dateien (CSS, Schriftarten/Fonts) werden über die
      Google-Domains fonts.googleapis.com und fonts.gstatic.com angefordert.
      Laut Google sind die Anfragen nach CSS und Schriften vollkommen getrennt
      von allen anderen Google-Diensten. Wenn Sie ein Google-Konto haben,
      brauchen Sie keine Sorge haben, dass Ihre Google-Kontodaten, während der
      Verwendung von Google Fonts, an Google übermittelt werden. Google erfasst
      die Nutzung von CSS (Cascading Style Sheets) und der verwendeten
      Schriftarten und speichert diese Daten sicher. Wie die Datenspeicherung
      genau aussieht, werden wir uns noch im Detail ansehen.
    </p>
    <h3>Was sind Google Fonts?</h3>
    <p>
      Google Fonts (früher Google Web Fonts) ist ein Verzeichnis mit über
      800 Schriftarten, die die <a
        href="https://de.wikipedia.org/wiki/Google_LLC?tid=121204212"
        >Google LLC</a
      > Ihren Nutzern kostenlos zu Verfügung stellen.
    </p>
    <p>
      Viele dieser Schriftarten sind unter der SIL Open Font
      License veröffentlicht, während andere unter
      der Apache-Lizenz veröffentlicht wurden. Beides sind freie
      Software-Lizenzen.
    </p>
    <h3>Warum verwenden wir Google Fonts auf unserer Webseite?</h3>
    <p>
      Mit Google Fonts können wir auf der eigenen Webseite Schriften nutzen, und
      müssen sie nicht auf unserem eigenen Server hochladen. Google Fonts ist
      ein wichtiger Baustein, um die Qualität unserer Webseite hoch zu halten.
      Alle Google-Schriften sind automatisch für das Web optimiert und dies
      spart Datenvolumen und ist speziell für die Verwendung bei mobilen
      Endgeräten ein großer Vorteil. Wenn Sie unsere Seite besuchen, sorgt die
      niedrige Dateigröße für eine schnelle Ladezeit. Des Weiteren sind Google
      Fonts sichere Web Fonts. Unterschiedliche Bildsynthese-Systeme (Rendering)
      in verschiedenen Browsern, Betriebssystemen und mobilen Endgeräten können
      zu Fehlern führen. Solche Fehler können teilweise Texte bzw. ganze
      Webseiten optisch verzerren. Dank des schnellen Content Delivery Network
      (CDN) gibt es mit Google Fonts keine plattformübergreifenden Probleme.
      Google Fonts unterstützt alle gängigen Browser (Google Chrome, Mozilla
      Firefox, Apple Safari, Opera) und funktioniert zuverlässig auf den meisten
      modernen mobilen Betriebssystemen, einschließlich Android 2.2+ und iOS
      4.2+ (iPhone, iPad, iPod). Wir verwenden die Google Fonts also, damit wir
      unser gesamtes Online-Service so schön und einheitlich wie möglich
      darstellen können.
    </p>
    <h3>Welche Daten werden von Google gespeichert?</h3>
    <p>
      Wenn Sie unsere Webseite besuchen, werden die Schriften über einen
      Google-Server nachgeladen. Durch diesen externen Aufruf werden Daten an
      die Google-Server übermittelt. So erkennt Google auch, dass Sie bzw. Ihre
      IP-Adresse unsere Webseite besucht. Die Google Fonts API wurde entwickelt,
      um Verwendung, Speicherung und Erfassung von Endnutzerdaten auf das zu
      reduzieren, was für eine ordentliche Bereitstellung von Schriften nötig
      ist. API steht übrigens für „Application Programming Interface“ und dient
      unter anderem als Datenübermittler im Softwarebereich.
    </p>
    <p>
      Google Fonts speichert CSS- und Schrift-Anfragen sicher bei Google und ist
      somit geschützt. Durch die gesammelten Nutzungszahlen kann Google
      feststellen, wie gut die einzelnen Schriften ankommen. Die Ergebnisse
      veröffentlicht Google auf internen Analyseseiten, wie beispielsweise
      Google Analytics. Zudem verwendet Google auch Daten des eigenen
      Web-Crawlers, um festzustellen, welche Webseiten Google-Schriften
      verwenden. Diese Daten werden in der BigQuery-Datenbank von Google Fonts
      veröffentlicht. Unternehmer und Entwickler nützen das
      Google-Webservice BigQuery, um große Datenmengen untersuchen und bewegen
      zu können.
    </p>
    <p>
      Zu bedenken gilt allerdings noch, dass durch jede Google Font Anfrage auch
      Informationen wie Spracheinstellungen, IP-Adresse, Version des Browsers,
      Bildschirmauflösung des Browsers und Name des Browsers automatisch an die
      Google-Server übertragen werden. Ob diese Daten auch gespeichert werden,
      ist nicht klar feststellbar bzw. wird von Google nicht eindeutig
      kommuniziert.
    </p>
    <h3>Wie lange und wo werden die Daten gespeichert?</h3>
    <p>
      Anfragen für CSS-Assets speichert Google einen Tag lang auf Ihren Servern,
      die hauptsächlich außerhalb der EU angesiedelt sind. Das ermöglicht uns,
      mithilfe eines Google-Stylesheets die Schriftarten zu nutzen. Ein
      Stylesheet ist eine Formatvorlage, über die man einfach und schnell z.B.
      das Design bzw. die Schriftart einer Webseite ändern kann.
    </p>
    <p>
      Die Font-Dateien werden bei Google ein Jahr gespeichert. Google verfolgt
      damit das Ziel, die Ladezeit von Webseiten grundsätzlich zu verbessern.
      Wenn Millionen von Webseiten auf die gleichen Schriften verweisen, werden
      sie nach dem ersten Besuch zwischengespeichert und erscheinen sofort auf
      allen anderen später besuchten Webseiten wieder. Manchmal aktualisiert
      Google Schriftdateien, um die Dateigröße zu reduzieren, die Abdeckung von
      Sprache zu erhöhen und das Design zu verbessern.
    </p>
    <h3>
      Wie kann ich meine Daten löschen bzw. die Datenspeicherung verhindern?
    </h3>
    <p>
      Jene Daten, die Google für einen Tag bzw. ein Jahr speichert können nicht
      einfach gelöscht werden. Die Daten werden beim Seitenaufruf automatisch an
      Google übermittelt. Um diese Daten vorzeitig löschen zu können, müssen Sie
      den Google-Support auf
      <a href="https://support.google.com/?hl=de&tid=121204212"
        >https://support.google.com/?hl=de&tid=121204212</a
      >
      kontaktieren. Datenspeicherung verhindern Sie in diesem Fall nur, wenn Sie
      unsere Seite nicht besuchen.
    </p>
    <p>
      Anders als andere Web-Schriften erlaubt uns Google uneingeschränkten
      Zugriff auf alle Schriftarten. Wir können also unlimitiert auf ein Meer an
      Schriftarten zugreifen und so das Optimum für unsere Webseite rausholen.
      Mehr zu Google Fonts und weiteren Fragen finden Sie auf
      <a href="https://developers.google.com/fonts/faq?tid=121204212"
        >https://developers.google.com/fonts/faq?tid=121204212</a
      >. Dort geht zwar Google auf datenschutzrelevante Angelegenheiten ein,
      doch wirklich detaillierte Informationen über Datenspeicherung sind nicht
      enthalten. Es ist relativ schwierig, von Google wirklich präzise
      Informationen über gespeicherten Daten zu bekommen.
    </p>
    <p>
      Welche Daten grundsätzlich von Google erfasst werden und wofür diese Daten
      verwendet werden, können Sie auch auf
      <a href="https://policies.google.com/privacy?hl=de&tid=121204212"
        >https://www.google.com/intl/de/policies/privacy/</a
      >
      nachlesen.
    </p>
    <h2>Google Analytics Datenschutzerklärung</h2>
    <p>
      Wir verwenden auf dieser Website Google Analytics der Firma Google LLC
      (1600 Amphitheatre Parkway Mountain View, CA 94043, USA) um Besucherdaten
      statistisch auszuwerten. Dabei verwendet Google Analytics zielorientierte
      Cookies.
    </p>
    <h3>Cookies von Google Analytics</h3>
    <ul>
      <li>
        _ga
        <ul>
          <li>Ablaufzeit: 2 Jahre</li>
          <li>Verwendung: Unterscheidung der Webseitenbesucher</li>
          <li>Beispielhafter Wert: GA1.2.1326744211.152121204212</li>
        </ul>
      </li>
      <li>
        _gid
        <ul>
          <li>Ablaufzeit: 24 Stunden</li>
          <li>Verwendung: Unterscheidung der Webseitenbesucher</li>
          <li>Beispielhafter Wert: GA1.2.1687193234.152121204212</li>
        </ul>
      </li>
      <li>
        _gat_gtag_UA_{{ trackingId }}
        <ul>
          <li>Ablaufzeit: 1 Minute</li>
          <li>
            Verwendung: Wird zum Drosseln der Anforderungsrate verwendet. Wenn
            Google Analytics über den Google Tag Manager bereitgestellt wird,
            erhält dieser Cookie den Namen _dc_gtm_{{ trackingId }}.
          </li>
          <li>Beispielhafter Wert: 1</li>
        </ul>
      </li>
    </ul>
    <p>
      Nähere Informationen zu Nutzungsbedingungen und Datenschutz finden Sie
      unter
      <a href="http://www.google.com/analytics/terms/de.html"
        >http://www.google.com/analytics/terms/de.html</a
      >
      bzw. unter
      <a href="https://support.google.com/analytics/answer/6004245?hl=de"
        >https://support.google.com/analytics/answer/6004245?hl=de</a
      >.
    </p>
    <h3>Pseudonymisierung</h3>
    <p>
      Unser Anliegen im Sinne der DSGVO ist die Verbesserung unseres Angebotes
      und unseres Webauftritts. Da uns die Privatsphäre unserer Nutzer wichtig
      ist, werden die Nutzerdaten pseudonymisiert.
    </p>
    <h3>Deaktivierung der Datenerfassung durch Google Analytics</h3>
    <p>
      Mithilfe des <strong>Browser-Add-ons zur Deaktivierung</strong> von Google
      Analytics-JavaScript (ga.js, analytics.js, dc.js) können Website-Besucher
      verhindern, dass Google Analytics ihre Daten verwendet.
    </p>
    <p>
      Sie können die Erfassung der durch das Cookie erzeugten und auf Ihre
      Nutzung der Website bezogenen Daten an Google sowie die Verarbeitung
      dieser Daten durch Google verhindern, indem Sie das unter dem folgenden
      Link verfügbare Browser-Plugin herunterladen und installieren:
      <a href="https://tools.google.com/dlpage/gaoptout?hl=de"
        >https://tools.google.com/dlpage/gaoptout?hl=de</a
      >
    </p>
    <p> </p>
    <h2>Google Analytics Deaktivierungslink</h2>
    <p>
      Wenn Sie auf folgenden <strong>Deaktivierungslink</strong> klicken, können
      Sie verhindern, dass Google weitere Besuche auf dieser Webseite erfasst.
      Achtung: Das Löschen von Cookies, die Nutzung des Inkognito/Privatmodus
      ihres Browsers, oder die Nutzung eines anderen Browsers führt dazu, dass
      wieder Daten erhoben werden.
    </p>
    <a
      class="gaoo-opt-out google-analytics-opt-out"
      href="#"
      @click="toggleAnalyticsOptOut"
      >Google Analytics deaktivieren</a
    >
    <p> </p>
    <h2>Google Analytics IP-Anonymisierung</h2>
    <p>
      Wir haben auf dieser Webseite die IP-Adressen-Anonymisierung von Google
      Analytics implementiert. Diese Funktion wurde von Google entwickelt, damit
      diese Webseite die geltenden Datenschutzbestimmungen und Empfehlungen der
      lokalen Datenschutzbehörden einhalten kann, wenn diese eine Speicherung
      der vollständigen IP-Adresse untersagen. Die Anonymisierung bzw.
      Maskierung der IP findet statt, sobald die IP-Adressen im Google
      Analytics-Datenerfassungsnetzwerk eintreffen und bevor eine Speicherung
      oder Verarbeitung der Daten stattfindet.
    </p>
    <p>
      Mehr Informationen zur IP-Anonymisierung finden Sie auf <a
        href="https://support.google.com/analytics/answer/2763052?hl=de"
        target="_blank"
        rel="noopener"
        >https://support.google.com/analytics/answer/2763052?hl=de</a
      >.
    </p>
    <h2>
      Google Analytics Berichte zu demografischen Merkmalen und Interessen
    </h2>
    <p>
      Wir haben in Google Analytics die Funktionen für Werbeberichte
      eingeschaltet. Die Berichte zu demografischen Merkmalen und Interessen
      enthalten Angaben zu Alter, Geschlecht und Interessen. Damit können wir
      uns – ohne diese Daten einzelnen Personen zuordnen zu können – ein
      besseres Bild von unseren Nutzern machen. Mehr über die Werbefunktionen
      erfahren Sie
      <a
        href="https://support.google.com/analytics/answer/3450482?hl=de_AT&utm_id=ad"
        target="_blank"
        rel="noopener"
        >auf https://support.google.com/analytics/answer/3450482?hl=de_AT&utm_id=ad</a
      >.
    </p>
    <p>
      Sie können die Nutzung der Aktivitäten und Informationen Ihres Google
      Kontos unter “Einstellungen für Werbung” auf
      <a href="https://adssettings.google.com/authenticated"
        >https://adssettings.google.com/authenticated</a
      >
      per Checkbox beenden.
    </p>
    <p style="margin-top: 15px">
      Quelle: Erstellt mit dem Datenschutz Generator von
      <a
        title="Datenschutz Generator von Content Marketing AdSimple"
        href="https://www.adsimple.at"
        target="_blank"
        rel="follow"
        >adsimple.at</a
      > in Kooperation mit
      <a href="https://www.urlaubsnews.at" target="_blank" rel="follow" title=""
        >urlaubsnews.at</a
      >
    </p>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "ImprintView",
  computed: {
    trackingId() {
      return process.env.VUE_APP_TRACKING_ID;
    },
    ...mapGetters(["analyticsOptOut"]),
  },
  methods: {
    toggleAnalyticsOptOut() {
      this.$ga.disable();
      this.setAnalyticsOptOut(true);
    },
    ...mapActions(["setAnalyticsOptOut"]),
  },
};
</script>

<style lang="scss" scoped>
.imprint-view-container {
  padding: $default-container-padding;

  h1 {
    &.dsgvo {
      padding: 0;
      margin: 40px 0 0 0;
    }
  }

  h2,
  h3 {
    margin-top: 30px;
    margin-bottom: 10px;

    &.header {
      margin-top: 0;
      margin-bottom: 10px;
      padding-left: 50px;
    }
  }

  p {
    margin: 10px 0;
  }

  ul {
    margin: 10px 0;
    padding-inline-start: 20px;
    li {
      list-style-type: disc;
    }
  }
}
</style>
